import { SCOPE_NAME } from '.';
import { Istore } from '../configureStore';
import { IuserInfo, IwarehouseList } from './types';

// System User Info
export const getUserInfoRedux = (state: Istore): IuserInfo =>
  state[SCOPE_NAME].userInfo;

export const getWareHouseListRedux = (state: Istore): IwarehouseList[] =>
  state[SCOPE_NAME].warehouseList;

export const getLoadingRedux = (state: Istore): boolean =>
  state[SCOPE_NAME].loading;
